import { render, staticRenderFns } from "./MedicationPlanFloatBtns.vue?vue&type=template&id=1213b783&"
import script from "./MedicationPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports